// seed-component-carousel.js

console.log('--- SEED-COMPONENT-CAROUSEL.JS --- LOADED AND EXECUTING ---');
alert('SEED-COMPONENT-CAROUSEL.JS LOADED'); // Intrusive, but will definitely tell us if it runs


if (!window.Carousel) { // Prevent re-definition if already loaded
  class Carousel extends HTMLElement {
    constructor() {
      super();
      // Default Swiper options for s-carousel instances
      // These can be overridden by data-options
      this.defaultOptions = {
        loop: false, // Default to false, can be true if specified in data-options
        slidesPerView: 'auto',
        grabCursor: true,
        centeredSlides: false,
        navigation: false, // Default to no navigation, enable via data-options
        pagination: false, // Default to no pagination, enable via data-options
      };
      this.selectors = {
        carousel: '[js-carousel]' // Inner div that Swiper targets
      };
      this.carousel = null; // To store the Swiper instance
      // console.log('S-CAROUSEL: Constructor for an s-carousel instance');
    }

    connectedCallback() {
      // console.log('S-CAROUSEL: connectedCallback for an s-carousel instance', this);
      let extendedOptions = {};
      if (this.dataset.options) {
        try {
          extendedOptions = JSON.parse(this.dataset.options);
        } catch (e) {
          console.error('S-CAROUSEL: Error parsing data-options JSON for', this, e);
          console.error('S-CAROUSEL: data-options string was:', this.dataset.options);
        }
      }
      // Merge default options with extended options from data-options
      this.options = Object.assign({}, this.defaultOptions, extendedOptions);
      this._initCarousel();
    }

    disconnectedCallback() {
      // console.log('S-CAROUSEL: disconnectedCallback for an s-carousel instance', this);
      if (this.carousel && typeof this.carousel.destroy === 'function') {
        // console.log(`S-CAROUSEL: Destroying Swiper for #${this.querySelector(this.selectors.carousel)?.id}`);
        this.carousel.destroy(true, true); // True to remove event listeners and styles
        this.carousel = null;
      }
      // Clean up enquire listeners if any were registered
      if (this.enquireHandler) {
        // enquire.unregister might need the query string and the handler.
        // This part depends on how enquire is used; for simplicity, often not explicitly unregistered here
        // unless it causes issues. If your 'config.mediaQueries[this.dataset.init]' is complex, review.
      }
    }

    _initCarousel() {
      const carouselInnerElement = this.querySelector(this.selectors.carousel);
      if (!carouselInnerElement) {
        console.error(`S-CAROUSEL: Carousel inner element ('${this.selectors.carousel}') not found within:`, this);
        return;
      }
      if (!carouselInnerElement.id) {
        console.error(`S-CAROUSEL: Carousel inner element ('${this.selectors.carousel}') requires an ID. Found in:`, this);
        return;
      }
      const swiperTargetId = `#${carouselInnerElement.id}`;

      // Check if Swiper is already initialized on this element by this component
      if (this.carousel && this.carousel.el === carouselInnerElement && this.carousel.initialized) {
        // console.log(`S-CAROUSEL: Swiper already initialized for ${swiperTargetId}. Updating.`);
        this.carousel.update();
        return;
      }

      // Responsive initialization logic (if 'data-init' and 'config.mediaQueries' are used)
      // Ensure 'config' and 'enquire' are available globally if this path is taken by ANY s-carousel on your site.
      if (this.dataset.init && typeof config !== 'undefined' && config.mediaQueries && config.mediaQueries[this.dataset.init] && typeof enquire !== 'undefined') {
        this.enquireHandler = {
          match: () => {
            console.log(`S-CAROUSEL (Responsive MATCH for ${swiperTargetId}): Attempting to initialize Swiper. Options:`, JSON.parse(JSON.stringify(this.options || {})));
            if (this.carousel && typeof this.carousel.destroy === 'function') this.carousel.destroy(true, true); // Destroy if existing
            try {
              this.carousel = new Swiper(swiperTargetId, this.options);
              console.log(`S-CAROUSEL (Responsive MATCH for ${swiperTargetId}): Swiper INITIALIZED. Instance:`, this.carousel, "Slides found:", this.carousel.slides.length);
              if (this.carousel.el) {
                this.carousel.el.dispatchEvent(new CustomEvent('s-carousel:swiper-initialized', { bubbles: true, detail: { swiper: this.carousel } }));
              }
            } catch (error) {
              console.error(`S-CAROUSEL (Responsive MATCH for ${swiperTargetId}): Error initializing Swiper:`, error, "Options used:", this.options);
            }
          },
          unmatch: () => {
            if (this.carousel && typeof this.carousel.destroy === 'function') {
              this.carousel.destroy(true, true);
              this.carousel = null;
              // console.log(`S-CAROUSEL (Responsive UNMATCH for ${swiperTargetId}): Swiper destroyed.`);
            }
          }
        };
        enquire.register(config.mediaQueries[this.dataset.init], this.enquireHandler);
      } else {
        // --- THIS IS THE CRITICAL PATH FOR YOUR MODAL SWIPER ---
        console.log(`S-CAROUSEL (Unconditional Init for ${swiperTargetId}): Attempting to initialize Swiper. Options:`, JSON.parse(JSON.stringify(this.options || {})));
        if (this.carousel && typeof this.carousel.destroy === 'function') this.carousel.destroy(true, true); // Destroy if existing, to re-init
        try {
          this.carousel = new Swiper(swiperTargetId, this.options);
          console.log(`S-CAROUSEL: Swiper INITIALIZED for ${swiperTargetId}. Instance:`, this.carousel, "Slides found by Swiper:", this.carousel.slides.length);
          // Make the Swiper instance accessible on the DOM element (the inner [js-carousel] div)
          // This is what product-gallery.js will look for (modalSwiperDiv.swiper)
          if (carouselInnerElement) {
            carouselInnerElement.swiper = this.carousel;
          }
          if (this.carousel.el) {
            this.carousel.el.dispatchEvent(new CustomEvent('s-carousel:swiper-initialized', { bubbles: true, detail: { swiper: this.carousel } }));
          }
        } catch (error) {
          console.error(`S-CAROUSEL: Error initializing Swiper for ${swiperTargetId}:`, error);
          console.error(`S-CAROUSEL: Options that caused error:`, this.options);
        }
      }
    }
  }

  // Define the custom element if it hasn't been defined yet
  if (!customElements.get('s-carousel')) {
    window.Carousel = Carousel; // Optional: make class available globally
    customElements.define('s-carousel', Carousel);
  }
}